export const WEB_TO_CLIENT_COMMAND = 'app/WEB_TO_CLIENT_COMMAND'


export function openClanSearch() {
    const webToClient = {
        handler: 'openWindow',
        params: {
            windowId: 'clan_search_window',
        },
    }

    return {
        type: WEB_TO_CLIENT_COMMAND,
        meta: { webToClient },
    }
}

export function openInvitations() {
    const webToClient = {
        handler: 'openWindow',
        params: {
            windowId: 'clan_personal_invites_window',
        },
    }

    return {
        type: WEB_TO_CLIENT_COMMAND,
        meta: { webToClient },
    }
}


// WEBPACK FOOTER //
// ./state/actions/app.js